import { inject, Injectable } from "@angular/core";
import {
  MC_FIELD_TYPE,
  MCFieldSchema,
  MCFieldAttributesService,
  MCFieldPatternService,
  MCFieldSectionsService,
  MCSectionSchema,
} from '@maslul/common-services';
import { MICustomFunctionsParams } from '../../models/fields/custom-function-params';
import { FieldsEventsService } from './events';
import { TranslateService } from '@ngx-translate/core';
import { FieldsOptionsService } from './options';
import { GeneralStore } from '../store/general';
import { NavigationService } from '../shared/navigation.service';
import { Sections } from './sections';

@Injectable({
  providedIn: 'root',
})
export class FieldsPropsService {

  private sectionsService = inject(MCFieldSectionsService);
  private fieldsEventsService = inject(FieldsEventsService);
  private fieldPatternService = inject(MCFieldPatternService);
  private fieldAttributesService = inject(MCFieldAttributesService);
  private translateService = inject(TranslateService);
  private fieldsOptionsService = inject(FieldsOptionsService);
  private navigationService = inject(NavigationService);



  getSectionProps(section: MCSectionSchema) {
    return {
      className: this.sectionsService.getSectionClass(section),
      hideLabel: Sections.sectionsToHideLabel.includes(section.section),
      hideCondition: section.hideCondition ?? undefined,
    };
  }

  getFieldConfigurationProps(customFunctionsObj: MICustomFunctionsParams) {
    const fieldSchema = customFunctionsObj.fieldSchema;
    return {
      //#region events
      change: this.fieldsEventsService.change(customFunctionsObj),
      keyUp: this.fieldsEventsService.keyUp(customFunctionsObj),
      focus: this.fieldsEventsService.focus(customFunctionsObj),
      onValueSelect: this.fieldsEventsService.onValueSelect(customFunctionsObj),
      onNewValueAdded:
        this.fieldsEventsService.onNewValueAdded(customFunctionsObj),
      //#endregion

      minLength: fieldSchema.minLength ?? null,
      maxLength: fieldSchema.maxLength ?? null,
      min: fieldSchema.min ?? null,
      max: fieldSchema.max ?? null,
      pattern: this.fieldPatternService.getPattern(fieldSchema),
      attributes: this.getAttribute(fieldSchema),
      options: this.fieldsOptionsService.getOptions(customFunctionsObj),
      relevantTooltip: fieldSchema.attributes?.find(a => a.key === 'hideTooltipMI')?.value === 'true'
        ? null
        : (fieldSchema.tooltip
          ? this.translateService.instant('labels.' + fieldSchema.tooltip)
          : fieldSchema.tooltip),
      dataType: MC_FIELD_TYPE[fieldSchema.type].toLowerCase(),
      //id: customFunctionsObj.rowId === undefined ? fieldSchema.name : `${fieldSchema.name}_${customFunctionsObj.rowId}`,
      dependencyChild: fieldSchema.dependencyChild,

      //#region expression
      hideCondition: fieldSchema.hideCondition,
      requiredCondition: fieldSchema.requiredCondition,
      disabledCondition: this.getDisabledCondition(
        fieldSchema.disableCondition,
      ),
      //#endregion

      //callbackAfterUpload: () => this.generalStore.setExternalSave(true),

      isInRepeat: customFunctionsObj.isInRepeat,
      isNoDownload: this.getIsNoDownload(),
    };
  }
  getDisabledCondition(disableCondition: string) {
    return this.navigationService.isNewRequest ? disableCondition : 'true';
  }
  getIsNoDownload() {
    return this.navigationService.isNewRequest;
  }

  getAttribute(fieldSchema: MCFieldSchema):
    | {
      [key: string]: string | number;
    }
    | undefined {
    return fieldSchema.attributes
      ? this.fieldAttributesService.convertAttributesListToDictionary(
        fieldSchema.attributes,
      )
      : undefined;
  }

  getRepeatProps(fieldSchema: MCFieldSchema) {
    return {
      minLength: fieldSchema.minLength,
      maxLength: fieldSchema.maxLength,
      min: fieldSchema.min,
      max: fieldSchema.max,
      //#region  expression
      hideCondition: fieldSchema.hideCondition,
      disabledCondition: this.getDisabledCondition(
        fieldSchema.disableCondition,
      ),
      //#endregion
    };
  }
}
